// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorBox_container__2VKOI"};